var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1548 5.1875H3.39502C3.05322 5.1875 2.76025 5.30957 2.51611 5.55371C2.27197 5.79785 2.1499 6.09082 2.1499 6.43262V12.0576C2.1499 12.4092 2.27197 12.707 2.51611 12.9512C2.76025 13.1953 3.05322 13.3174 3.39502 13.3174H12.1548C12.4966 13.3174 12.7896 13.1953 13.0337 12.9512C13.2778 12.707 13.3999 12.4092 13.3999 12.0576V6.43262C13.3999 6.09082 13.2778 5.79785 13.0337 5.55371C12.7896 5.30957 12.4966 5.1875 12.1548 5.1875ZM6.09033 9.75781L7.10107 10.6367C7.19873 10.7148 7.30371 10.7759 7.41602 10.8198C7.52832 10.8638 7.64795 10.8857 7.7749 10.8857C7.90186 10.8857 8.02148 10.8638 8.13379 10.8198C8.24609 10.7759 8.35107 10.7148 8.44873 10.6367L9.45947 9.75781L9.43018 9.78711L11.7153 12.0576H3.83447L6.11963 9.78711L6.09033 9.75781ZM3.39502 11.6182V7.39941L5.65088 9.3623L3.39502 11.6182ZM9.89893 9.3623L12.1548 7.39941V11.6182L9.89893 9.3623ZM12.1548 6.43262V6.56445L8.03857 10.168C7.97021 10.2266 7.88232 10.2559 7.7749 10.2559C7.66748 10.2559 7.57959 10.2266 7.51123 10.168L3.39502 6.56445V6.43262H12.1548Z",
    fill: "#F985C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.7e1d804cba759426dbe156cd2a8ee013.svg";
export { ForwardRef as ReactComponent };